import repository from './repsitory'

const resource = '/section'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addSection (data) {
        return repository.post(`${resource}`, data)
    },
    updateSection (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
